import {LangKeys} from "locales/i18n";

export default {
   [LangKeys.en]: {
       title: "Privacy | Pumpkin Meet",
       description: "",
   },
}